import { useNavigate } from "react-router-dom";
import {
  useClearMyListMutation,
  useGetMyListQuery,
  useRemoveFromMyListMutation,
} from "../features/api/myListApiSlice";
import LoadingSpinner from "../components/loader/Loader";
import useAuth from "../hooks/useAuth";
import toast from "react-hot-toast";
import "./page.scss";
import ConfirmationModal from "../components/confirmation/ConfirmationModal";
import { useState } from "react";
import PaginatedVideosGrid from "../features/video/PaginatedVideosGrid";

const MyList = () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, isLoading } = useGetMyListQuery(undefined, {
    skip: !isLoggedIn,
  });
  const [clearMyList, { isLoading: isClearLoading }] = useClearMyListMutation();
  const [removeFromMyList, { isLoading: isRemovingLoading }] =
    useRemoveFromMyListMutation();

  const myList = data?.myList || [];

  const handleRemove = async (videoId) => {
    try {
      const res = await removeFromMyList(videoId).unwrap();
      toast.success(res?.message || "Video removed from your list");
    } catch (error) {
      toast.error(error?.data?.message || "Failed to remove video");
    }
  };

  const handleDeleteClick = () => {
    setIsModalOpen(true);
  };

  const handleCancelDelete = () => {
    setIsModalOpen(false);
  };

  const handleConfirmDelete = async () => {
    try {
      const res = await clearMyList().unwrap();
      toast.success(res?.message || "Your list has been cleared.");
      setIsModalOpen(false);
    } catch (err) {
      if (err.status === "FETCH_ERROR") {
        toast.error("Network Error: Please check your connection.");
      } else {
        toast.error(err.data?.message || "Failed to clear your list.");
      }
    }
  };

  if (isLoading || isRemovingLoading || isClearLoading)
    return <LoadingSpinner />;

  return (
    <div className="main_wrapper">
      <div className="page-container">
        <div className="top-page-flex">
          <h2>My List</h2>
          <button onClick={handleDeleteClick}>Clear List</button>
        </div>
        <div className="related-videos">
          <PaginatedVideosGrid videos={myList} navigate={navigate} />
        </div>
        <ConfirmationModal
          isOpen={isModalOpen}
          message="Are you sure you want to clear your list? This action cannot be undone."
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
        />
      </div>
    </div>
  );
};

export default MyList;
